type LogLevel = "silent" | "error" | "warn" | "info" | "debug";

const levelOrder: Record<LogLevel, number> = {
  silent: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4,
};

const isLogLevel = (value: unknown): value is LogLevel =>
  value === "silent" ||
  value === "error" ||
  value === "warn" ||
  value === "info" ||
  value === "debug";

const resolveLogLevel = (): LogLevel => {
  const envLevel = import.meta.env.VITE_LOG_LEVEL;
  if (isLogLevel(envLevel)) return envLevel;
  return import.meta.env.DEV ? "warn" : "error";
};

export const configureConsoleLogging = () => {
  if (typeof console === "undefined") return;

  const level = resolveLogLevel();
  const threshold = levelOrder[level];
  const original = {
    error: console.error.bind(console),
    warn: console.warn.bind(console),
    info: console.info.bind(console),
    log: console.log.bind(console),
    debug: console.debug.bind(console),
  };

  const allow = (method: LogLevel) => levelOrder[method] <= threshold;
  const noop = () => {};

  console.error = allow("error") ? original.error : noop;
  console.warn = allow("warn") ? original.warn : noop;
  console.info = allow("info") ? original.info : noop;
  console.log = allow("info") ? original.log : noop;
  console.debug = allow("debug") ? original.debug : noop;
};
